import { useEffect } from "react";

/**
 * OtelyaWidget — dogfoods the "Powered by Otelya" chat widget on the public site.
 * Loads /widget.js with the well-known HQ token so visitors can chat with Otelya herself.
 * Mounted on all public pages (Landing, Founder, Blog, AuthPage) — NOT on the dashboard.
 */
export function OtelyaWidget() {
  useEffect(() => {
    if (document.getElementById("otelya-hq-widget")) return;
    const s = document.createElement("script");
    s.id = "otelya-hq-widget";
    s.src = "/widget.js";
    s.setAttribute("data-widget-token", "otelya-hq");
    s.defer = true;
    document.body.appendChild(s);
    return () => {
      // Cleanup when navigating to a route where widget shouldn't show (e.g. dashboard).
      document.getElementById("otelya-hq-widget")?.remove();
      document.getElementById("otelya-w-style")?.remove();
      document.querySelectorAll(".otelya-w-launcher, .otelya-w-panel").forEach((el) => el.remove());
    };
  }, []);
  return null;
}

export default OtelyaWidget;

